import React, { useMemo, useState } from "react"
import { ArrowUpRight, TrendingUp, Filter, Link as LinkIcon, BarChart3, Copy } from "lucide-react"
import img1 from "../public/imgs/1.png"
import img2 from "../public/imgs/2.png"
import img3 from "../public/imgs/3.png"
import img4 from "../public/imgs/4.png"
import img5 from "../public/imgs/5.png"
import img6 from "../public/imgs/6.png"
import img7 from "../public/imgs/7.png"
import img8 from "../public/imgs/8.png"
import img9 from "../public/imgs/9.png"
import img10 from "../public/imgs/10.png"
import img11 from "../public/imgs/11.png"
import img12 from "../public/imgs/12.png"
import logoSmall from "../public/imgs/logo-small.png"

// ---------- Demo Data (edit/extend freely) ----------
const CHARTS = [
  {
    id: "c1",
    title: "Chart 1",
    potentialX: 45,
    marketMaking: ["$5.03M ATH"],
    description:
      "Aggressive backrun entries on sudden inflow spikes ride the first redistribution leg, exit on tape exhaustion.",
    projectUrl: "https://gmgn.ai/sol/token/8fdBKZq7wo9fJbsZEZhq6omCgvKzLt97HY9XaGgqpump",
    chartImg: img1,
  },
  {
    id: "c2",
    title: "Chart 2",
    potentialX: 18,
    marketMaking: ["$4.88M ATH"],
    description:
      "TWAP ladder provides baseline liquidity while fading over-extensions back to VWAP bands.",
    projectUrl: "https://gmgn.ai/sol/token/EnbYiKqWdzKfuN12QZ33tYm9ysy4Bjhpf7XU2RY3pump",
    chartImg: img2,
  },
  {
    id: "c3",
    title: "Chart 3",
    potentialX: 76,
    marketMaking: ["$913k ATH"],
    description:
      "Harvest tails during volatility clusters pyramids only on expansion candles with tight trailing.",
    projectUrl: "https://gmgn.ai/sol/token/9HAZrXJx5QXzBfJynRQXkHr9DG4Kk8dzuuQnMfz6pump",
    chartImg: img3,
  },
  {
    id: "c4",
    title: "Chart 4",
    potentialX: 9,
    marketMaking: ["$863k ATH"],
    description:
      "Passive grid within defined range widen spread into liquidity droughts to capture maker rebate.",
    projectUrl: "https://gmgn.ai/sol/token/DZpa4peCErsNzsYJ69XYYTSjZGDQhuexnzj7EiZ1pump",
    chartImg: img4,
  },
  {
    id: "c5",
    title: "Chart 5",
    potentialX: 33,
    marketMaking: ["$195k ATH"],
    description:
      "Micro-snipes following news pulse enter post-first wick, exit into second leg distribution.",
    projectUrl: "https://gmgn.ai/sol/token/EQS494mD5k7reySGrJUmivpjPghRn7sHMJyPBVo6pump",
    chartImg: img5,
  },
  {
    id: "c6",
    title: "Chart 6",
    potentialX: 12,
    marketMaking: ["$412k ATH"],
    description:
      "Depth provisioning around peg with elastic spread and reactive inventory skew.",
    projectUrl: "https://gmgn.ai/sol/token/CopcZLDYyoeaVChYYD3CDiCLEhVNYxjUrtKPmHN8pump",
    chartImg: img6,
  },
  {
    id: "c7",
    title: "Chart 7",
    potentialX: 25,
    marketMaking: ["$3.31M ATH"],
    description:
      "Rotate between pools on fee/TVL edge front-run liquidity vacuums as capital migrates.",
    projectUrl: "https://gmgn.ai/sol/token/8bXthY9c4aZn4fg7iB1ec8jMbjqY31b9khNPjsUvpump",
    chartImg: img7,
  },
  {
    id: "c8",
    title: "Chart 8",
    potentialX: 55,
    marketMaking: ["$1.63M ATH"],
    description:
      "Ride stop cascades across local highs scale out on liquidity walls and delta slowdowns.",
    projectUrl: "https://gmgn.ai/sol/token/Cz5oaw1XxGsPVPsEMu3SZEJ9A6vpcrVqaBAwP3ePpump",
    chartImg: img8,
  },
  {
    id: "c9",
    title: "Chart 9",
    potentialX: 5,
    marketMaking: ["$128k ATH"],
    description:
      "Counter-move clips back to VWAP with micro take-profits and strict time stops.",
    projectUrl: "https://gmgn.ai/sol/token/DAGhj6zSc3ECAXB1VNVMF2pfMRoZJcpWetS5VVZxpump",
    chartImg: img9,
  },
  {
    id: "c10",
    title: "Chart 10",
    potentialX: 25,
    marketMaking: ["$133k ATH"],
    description:
      "Rotate between pools on fee/TVL edge front-run liquidity vacuums as capital migrates.",
    projectUrl: "https://gmgn.ai/sol/token/FfNrWEjpAms4m3hmBc4fjpXgm8MM1MQQtygFrJPYpump",
    chartImg: img10,
  },
  {
    id: "c11",
    title: "Chart 11",
    potentialX: 55,
    marketMaking: ["$707k ATH"],
    description:
      "Ride stop cascades across local highs scale out on liquidity walls and delta slowdowns.",
    projectUrl: "https://gmgn.ai/sol/token/6tbe2qsKdbPvN19b1nbi1VrBkRER5RzGqR3qz4Qspump",
    chartImg: img11,
  },
  {
    id: "c12",
    title: "Chart 12",
    potentialX: 5,
    marketMaking: ["$330k ATH"],
    description:
      "Counter-move clips back to VWAP with micro take-profits and strict time stops.",
    projectUrl: "https://gmgn.ai/sol/token/E2ztpQ8G5pvwZrqLVNQAL14rSWWcaagvD1dDTyvppump",
    chartImg: img12,
  },
]

const TAGS = Array.from(new Set(CHARTS.flatMap((c) => c.marketMaking))).sort()

// ---------- Small UI helpers ----------
const Badge = ({ children }) => (
  <span className="inline-flex items-center rounded-full border px-2 py-1 text-xs font-medium leading-none">
    {children}
  </span>
)

const ToggleChip = ({
  label,
  active,
  onToggle,
}) => (
  <button
    onClick={onToggle}
    className={[
      "rounded-full border px-3 py-1 text-sm",
      active ? "bg-black text-white" : "hover:bg-zinc-100",
    ].join(" ")}
  >
    {label}
  </button>
)

const Card = ({ c }) => (
  <div className="group relative flex flex-col overflow-hidden rounded-2xl border bg-white shadow-sm transition hover:shadow-md">
    <div className="relative">
      {/* Chart Image */}
      <img
        src={c.chartImg}
        alt={`${c.title} preview`}
        className="h-80 w-full object-cover"
        loading="lazy"
      />
      {/* Potential badge */}
      <div className="absolute left-3 top-3">
        <div className="flex items-center gap-1 rounded-full bg-white/90 px-2 py-1 text-xs font-semibold shadow-sm">
          <TrendingUp className="h-3.5 w-3.5" />
          <span>{c.potentialX}x Potential</span>
        </div>
      </div>
    </div>

    <div className="flex flex-1 flex-col gap-3 p-4">
      <div className="flex items-start justify-between gap-3">
        <div>
          <h3 className="text-lg font-semibold leading-tight">{c.title}</h3>
          <p className="mt-1 line-clamp-2 text-sm text-zinc-600">{c.description}</p>
        </div>
        <Badge>
          <BarChart3 className="mr-1 h-3.5 w-3.5" />
          {c.marketMaking[0]}
        </Badge>
      </div>

      <div className="mt-auto flex items-center gap-2 pt-2">
        <a
          href={c.projectUrl}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-1 rounded-xl border px-3 py-2 text-sm font-medium hover:bg-zinc-50"
        >
          <LinkIcon className="h-4 w-4" /> View Project
        </a>
        <a
          href={"https://t.me/merunas?text=Hi I want to subscribe and create the " + c.title}
          target="_blank"
          className="inline-flex items-center gap-1 rounded-xl bg-black px-3 py-2 text-sm font-semibold text-white hover:bg-zinc-800"
        >
          Market Make This Chart <ArrowUpRight className="h-4 w-4" />
        </a>
      </div>
    </div>
  </div>
)

// ---------- Main Component ----------
export default function ChartGallery() {
  const [selected, setSelected] = useState([])

  const filtered = useMemo(() => {
    let list = CHARTS.filter((c) => {
      const matchesTag =
        selected.length === 0 || selected.every((t) => c.marketMaking.includes(t))
      return matchesTag
    })

    return list
  }, [selected])

  const toggle = (t) =>
    setSelected((prev) => (prev.includes(t) ? prev.filter((x) => x !== t) : [...prev, t]))

  return (
    <div className="min-h-screen bg-gradient-to-b from-zinc-50 to-white text-zinc-900">
      <header className="sticky top-0 z-10 border-b bg-white/80 backdrop-blur">
        <div className="mx-auto flex max-w-7xl flex-col gap-4 px-4 py-5 md:flex-row md:items-center md:justify-between">
          <div>
            <div className="flex items-center gap-3 mb-2">
              <img src={logoSmall} alt="MEVDAO Logo" className="h-10 w-10" />
              <h1 className="text-2xl font-bold">MEVDAO Marker Maker</h1>
            </div>
            <p className="mt-1 text-sm text-zinc-600">
              Launch your solana coin and market make a chart that brings people to your project with deep psychology
            </p>
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-7xl px-4 py-6">
        {/* Tag Filters */}
        <div className="mb-5 flex flex-wrap gap-2">
          {TAGS.map((t) => (
            <ToggleChip key={t} label={t} active={selected.includes(t)} onToggle={() => toggle(t)} />
          ))}
          {selected.length > 0 && (
            <button
              onClick={() => setSelected([])}
              className="rounded-full border px-3 py-1 text-sm text-zinc-600 hover:bg-zinc-100"
            >
              Clear
            </button>
          )}
        </div>

        {/* 3 per row grid (responsive) */}
        <div className="grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-3">
          {filtered.map((c) => (
            <Card key={c.id} c={c} />
          ))}
        </div>

        {filtered.length === 0 && (
          <div className="mt-20 text-center text-sm text-zinc-500">No matches. Try removing filters.</div>
        )}

        {/* Simple how-it-works */}
        <section id="recreate" className="mt-14 rounded-2xl border bg-white p-6">
          <h2 className="text-xl font-semibold">How to become the market maker</h2>
          <ol className="mt-3 list-decimal space-y-2 pl-5 text-sm text-zinc-700">
            <li>Pick a chart tile and open the project page to study the tape and structure</li>
            <li>Select the matching market-making template to create that chart</li>
            <li>Deposit funds to create volume, you can exit anytime</li>
            <li>Deploy and market make the chart to bring investors to your project</li>
          </ol>
        </section>

        <footer className="mt-10 py-8 text-center text-xs text-zinc-500">
          © {new Date().getFullYear()} — MEVDAO.
        </footer>
      </main>
    </div>
  )
}
